export function millingNameFromFile(filename) {
  let base = (filename || "").replace(/\.(dxf|png|jpe?g)$/i, "").normalize("NFC");
  // Splitter exports use model-code + template part name, e.g. A430I-Ráma.
  const prefix = base.match(/^([\p{L}\p{N}]+)-/u)?.[1];
  if (prefix && /\p{N}/u.test(prefix)) base = prefix;
  else base = base.replace(/[-_\s]+(?:standard|alap|ráma|rama|fiókelő|fiokelo|joly|ajtó|ajto)(?:[-_\s]*\d+)?$/iu, "");
  return base.replace(/[^\p{L}\p{N}]/gu, "").slice(0, 255);
}

export function withFileDerivedName(previous, next) {
  if (previous.millingId || previous._nameEdited || previous.name?.trim()) return next;
  const file = next.dxfFile !== previous.dxfFile ? next.dxfFile
    : next.file !== previous.file ? next.file : null;
  return file ? { ...next, name: millingNameFromFile(file.name) } : next;
}

export function newMillingVariant(variants) {
  const presets = [
    { name: "Ráma", selectionMode: "manual", maxSizeMm: null },
    { name: "Fiókelő", selectionMode: "height", maxSizeMm: 150 },
    { name: "Joly", selectionMode: "width", maxSizeMm: 150 }
  ];
  const preset = presets[variants.length] || { name: `Változat ${variants.length + 1}`, selectionMode: "manual", maxSizeMm: null };
  let name = preset.name, suffix = 2;
  const names = new Set(variants.map(v => v.name.trim().toLocaleLowerCase()));
  while (names.has(name.toLocaleLowerCase())) name = `${preset.name} ${suffix++}`;
  return { variantId: crypto.randomUUID(), imageKey: "", minSizeMm: null, ...preset, name };
}
